import React, { Fragment } from 'react';
import Ghost from './ghost';
import Background from './background';

const GertieGhost = ({ width = 346, height = 189 }) => {
  return (
    <Fragment>
      <Ghost width={width} height={height} />
      <Background width={width} height={height} />
    </Fragment>
  );
};

export default GertieGhost;
